export const MOOD_OPTIONS = [
  { value: 'great', label: '😊 Great', color: 'bg-green-100' },
  { value: 'good', label: '🙂 Good', color: 'bg-blue-100' },
  { value: 'okay', label: '😐 Okay', color: 'bg-yellow-100' },
  { value: 'stressed', label: '😟 Stressed', color: 'bg-orange-100' },
  { value: 'overwhelmed', label: '😰 Overwhelmed', color: 'bg-red-100' },
];

export const VALIDATIONS = {
  great: "It's wonderful to hear you're feeling great today!",
  good: "That's great that you're feeling good.",
  okay: "It's normal to have days like this.",
  stressed: "Stress is a natural response. You're doing well by checking in.",
  overwhelmed: "It's okay to feel overwhelmed. You're taking a positive step by reflecting.",
};

export const TIPS = {
  great: "Keep this momentum going—share your positive energy with someone today.",
  good: "Consider what's contributing to your good mood and do more of it.",
  okay: "Try a 5-minute walk or stretch to shift your energy.",
  stressed: "Take three deep breaths. You have the strength to handle this.",
  overwhelmed: "Break your tasks into smaller steps. One thing at a time.",
};

export const STRESS_TIPS = {
  high: "Consider reaching out to someone you trust.",
  medium: "A short break might help reset your mind.",
  low: "You're managing well. Keep up the self-awareness.",
};
